export default function findOperatorPrintText(cashier, allOperators){
    if(cashier && allOperators.length > 0){
        const operator = allOperators.find(op => op.username === cashier);
        if(operator){
            return operator.printText || cashier;
        }
    }
    return cashier;
}
